import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";

import ShareSpaceRecipient from "models/interfaces/share-spaces/share-space-recipient";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const defaultValues: ShareSpaceRecipient =
    RecordUtils.auditableDefaultValuesFactory<ShareSpaceRecipient>({
        shareSpaceId: undefined,
        email: undefined,
        shareSpace: undefined,
    });

// #endregion Constants

export default class ShareSpaceRecipientRecord
    extends Record(defaultValues)
    implements ShareSpaceRecipient
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: ShareSpaceRecipient) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor
}
